<template>
	<div>
		<div class="text-h5">Tambah Pengiriman Retur</div>
		<v-card class="mt-3" outlined>
			<v-card-text>
				<v-alert v-for="(alert, index) in alertMultiple" v-model="alert.show" :key="index" dismissible type="error" elevation="1">
					{{alert.message}}
				</v-alert>
				<v-form>
					<v-row>
						<v-col cols="12" md="3">
							<v-autocomplete :items="returforDelivery" v-model="por_selected" item-text="por_code" label="Kode Retur" return-object no-data-text="Tidak ada data yang sesuai" outlined dense color="cyan darken-2" item-color="cyan darken-2">
							</v-autocomplete>
						</v-col>
						<v-col cols="12" md="3" v-if="false">
							<v-row>
								<v-col cols="12" class="py-0">
									<v-menu v-model="menu" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
										<template v-slot:activator="{ on, attrs }">
											<v-text-field :value="convertDate(est_sent_date)" label="Estimasi Kirim" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined dense color="cyan darken-2"></v-text-field>
										</template>
										<v-date-picker color="cyan darken-2" @input="menu = false" v-model="est_sent_date" locale="id"></v-date-picker>
									</v-menu>
								</v-col>
								<v-col cols="12" class="py-0">
									<v-menu v-model="menu2" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
										<template v-slot:activator="{ on, attrs }">
											<v-text-field :value="convertDate(est_received_date)" label="Estimasi Terima" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined dense color="cyan darken-2"></v-text-field>
										</template>
										<v-date-picker color="cyan darken-2" @input="menu2 = false" v-model="est_received_date" locale="id"></v-date-picker>
									</v-menu>
								</v-col>
							</v-row>
						</v-col>
						<v-col cols="12" md="9">
							<v-textarea v-model="note" label="Catatan" outlined dense color="cyan darken-2" height="106" no-resize></v-textarea>
						</v-col>
						<v-col cols="12" class="pt-0">
							<v-simple-table fixed-header dense class="pt-3 white-row">
								<template v-slot:default>
									<thead>
										<tr>
											<th width="30%" class="text-left">Nama Produk</th>
											<th width="10%" class="text-left">Kode Produk</th>
											<th width="15%" class="text-left">Jumlah Permintaan</th>
											<th width="15%" class="text-left">Jumlah Dikirim</th>
											<th width="15%" class="text-left">Jumlah Terkirim</th>
											<th width="15%" class="text-left">Jumlah</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="product in productToDeliver" :key="product.product_id">
											<td> {{ product.supplier_product_name }} </td>
											<td> {{ product.supplier_product_code }} </td>
											<td> {{ product.por_detail_quantity_approved }} </td>
											<td> {{ product.por_detail_quantity_transport }} </td>
											<td> {{ product.por_detail_quantity_delivered }} </td>
											<td>
												<v-currency-field v-model.lazy="product.deliver" :rules="[inputrules.required]" outlined dense hide-details="auto" background-color="white" class="py-3 details-mb-0"></v-currency-field>
											</td>
										</tr>
									</tbody>
									<tfoot>
									</tfoot>
								</template>
							</v-simple-table>
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>
			<v-card-actions class="px-3 pb-3">
				<v-spacer></v-spacer>
				<v-btn color="cyan darken-2" :disabled="!por_selected" depressed class="text-capitalize" dark @click="proccessKirim">Proses</v-btn>
			</v-card-actions>
		</v-card>
	</div>
</template>

<script>

import {mapActions, mapState, mapMutations} from 'vuex'

export default {
	inject: ['theme'],
	data() {
		return {
			menu: false,
			menu2: false,
			list_payment: ['Lunas', 'Tempo'],
			por_selected: '',
			est_sent_date: '',
			est_received_date: '',
			note: '',
		}
	},
	props: {
	},
	computed: {
		...mapState('returSupplier', ['detailRetur']),
		...mapState('pdoReturSupplier', ['response', 'returforDelivery', 'alertMultiple']),
		...mapState('auth', ['userData']),

		productToDeliver() {
			let product = []
			if (this.detailRetur.por_detail) {
				product = this.detailRetur.por_detail.map((el) => {
					el.deliver = el.por_detail_quantity_approved - el.por_detail_quantity_delivered - el.por_detail_quantity_transport
					return el
				})
			}
			return product
		}
	},
	methods: {
		...mapActions('returSupplier', ['getDetailRetur']),
		...mapActions('pdoReturSupplier', ['createRD', 'getReturforDelivery']),
		...mapMutations('returSupplier', ['setDetailRetur', 'clearDataRetur']),
		...mapMutations('pdoReturSupplier', ['saveResponse', 'clearDataReturDelivery']),

		deletefromRetur(idProduct) {
			const indexProduct = this.supplierProducts.findIndex(el => el.product_id == idProduct)
			this.supplierProducts[indexProduct].selected = false
		},
		proccessKirim() {
			let product = this.productToDeliver.map( (el) => {
				return {
					product_id : el.por_detail_product_id,
					product_name : el.por_detail_product_name,
					quantity : el.deliver
				}
			})
			let params = {
				por_id: this.detailRetur.por_id,
				estimated_sent_date: this.est_sent_date,
				estimated_received_date: this.est_received_date,
				note: this.note,
				product: product
			}
			this.createRD(params).then(() => {
				if (this.response.code == 200) {
					this.getReturforDelivery({limit: 100})
					this.resetForm()
				}
			})
		},
		getDetail(code) {
			this.getDetailRetur(code)
		},
		resetForm() {
			this.saveResponse({
				code: '',
				message: ''
			})
			this.setDetailRetur({})
			this.por_selected = ''
			this.est_sent_date = ''
			this.est_received_date = ''
			this.note = ''
		}
	},
	created() {
		this.$store.dispatch('setPageTitle', `Tambah Pengiriman Retur`);
		this.getReturforDelivery({limit: 100})
	},
	beforeDestroy() {
		this.clearDataReturDelivery()
		this.clearDataRetur()
	},
	watch: {
		por_selected(val) {
			this.setDetailRetur({})
			if (val.por_code) {
				this.getDetail(val.por_code)
			}
		}
	}
}
</script>